'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/10/5.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalForgetPasswordRealChange = (_dec = (0, _reduxForm.reduxForm)({
  form: 'forgetPasswordRealChange',
  fields: ['newword', 'confirmword']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalForgetPasswordRealChange, _Component);

  function PersonalForgetPasswordRealChange() {
    (0, _classCallCheck3.default)(this, PersonalForgetPasswordRealChange);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalForgetPasswordRealChange).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalForgetPasswordRealChange, [{
    key: 'render',
    value: function render() {
      var styles = require('./PersonalForgetPasswordRealChange.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var newword = _props$fields.newword;
      var confirmword = _props$fields.confirmword;
      var handleSubmit = _props.handleSubmit;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.component },
          _react2.default.createElement(_GoeasyInputField2.default, { label: '新密码：', inputType: 'password',
            inputPlaceholder: '长度为6-20位数字字母', formProps: newword }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '再次输入密码：', inputType: 'password', inputPlaceholder: '',
            formProps: confirmword }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '提交' })
        )
      );
    }
  }]);
  return PersonalForgetPasswordRealChange;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PersonalForgetPasswordRealChange;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalForgetPasswordRealChange/PersonalForgetPasswordRealChange.js
 ** module id = 1396
 ** module chunks = 0
 **/